import uuid from 'react-uuid';
import '../styles/navbar.css';
import { useEffect, useState } from 'react';

const links = [
	{
		label: 'Project',
		subLinks: [
			{ label: 'Description', path: '/description' },
			{ label: 'Contribution', path: '/contribution' },
		],
	},
	{
		label: 'Wet Lab',
		subLinks: [
			{ label: 'Engineering', path: '/engineering' },
			{ label: 'Experiments', path: '/experiment' },
			{ label: 'Proof of Concept', path: '/ProofofConcept' },
			{ label: 'Parts', path: '/parts' },
			{ label: 'Safety', path: '/safety' },
			{ label: 'Notebook', path: '/notebook' },
		],
	},
	{ label: 'Hardware', subLinks: null, path: '/Hardware' },
	{
		label: 'Human Practices',
		subLinks: [
			{ label: 'IHP', path: '/human-practices' },
			{ label: 'Entrepreneurship', path: '/entrepreneurship' },
			{ label: 'Inclusivity', path: '/inclusivity' },
			{ label: 'SDGs', path: '/sustainable' },
		],
	},
	{ label: 'Model', path: '/Model', isTitle: true },
	{ label: 'Education', path: '/education', isTitle: true },
	{
		label: 'Software',
		subLinks: [
			{ label: 'Software', path: '/software' },
			{ label: 'Mosquito Egg Counter', path: '/mosquito-egg-counter' },
			{ label: 'Software X Drylab Model', path: '/software-drylab-model' },
		],
	},
	{
		label: 'Team',
		subLinks: [
			{ label: 'Team', path: '/team' },
			{ label: 'Attributions', path: '/attributions' },
		],
	},
	{ label: 'Awards', subLinks: null, path: '/awards' },
];

const baseURL = process.env.PUBLIC_URL;

const Navbar = () => {
	let logo = 'https://static.igem.wiki/teams/5066/global/i2024-logo.webp';
	let hamburgerIcon =
		'https://static.igem.wiki/teams/5066/global/hamburger-icon-purple.png';
	let logoHover = 'https://static.igem.wiki/teams/5066/global/logo2.png';

	const [width, setWidth] = useState(window.innerWidth);
	const [menuOpen, setMenuOpen] = useState(false);
	const [scrollWidth, setScrollWidth] = useState(0);

	useEffect(() => {
		const resize = () => setWidth(window.innerWidth);
		window.addEventListener('resize', resize);
		return () => window.removeEventListener('resize', resize);
	}, []);

	useEffect(() => {
		if (menuOpen) document.body.style.overflow = 'hidden';
		else document.body.style.overflow = 'scroll';
	}, [menuOpen]);

	const handleScroll = () => {
		const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
		const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
		const scrollPercent = (scrollTop / scrollHeight) * 100;
		setScrollWidth(scrollPercent);
	};

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	const toggleMenu = () => {
		setMenuOpen(!menuOpen);
	};


	return (
		<>
			<nav className='text-left w-full h-[100px] fixed shadow-xl rounded-sm bg-[#FFFBF2]/95 z-50 shadow-[0_4px_8px_0_rgba(133,104,70,.1)]'>
				<ul className='w-screen h-full flex items-center pr-20 select-none'>
					<li className='h-full mx-3'>
						<a href={baseURL}>
							<div className='image-container'>
								<img className='original-image' src={logo} alt='Team Logo' />
								<img className='hover-image' src={logoHover} alt='Team' />
							</div>
						</a>
					</li>
					<li className='grow' />
					{width >= 1120 ? (
						links.map(({ label, subLinks, path }) => {
							return (
								<li key={uuid()} className='mx-4 cursor-pointer'>
									<div className='hoverTrig'>
										{subLinks ? (
											<>
												<h2 className='leading-normal font-normal text-[16px] xl:text-[18px]'>{label}</h2>
												<ul className='subMenu'>
													{subLinks.map(({ label, path }) => {
														return (
															<li key={uuid()}>
																<a href={`${baseURL}${path}`}>
																	<h1>{label}</h1>
																</a>
															</li>
														);
													})}
												</ul>
											</>
										) : (
											<a href={`${baseURL}${path}`}>
												<h1 className='leading-normal font-normal text-[16px] xl:text-[18px]'>{label}</h1>
											</a>
										)}
									</div>
								</li>
							);
						})
					) : (
						<>
							<li className='cursor-pointer' onClick={toggleMenu}>
								<img className='w-8 h-8' src={hamburgerIcon} alt='Menu' />
							</li>
							{menuOpen && (
								<div
									className="fixed top-[100px] h-screen right-0 w-full bg-[#FFFBF2] flex flex-col items-center pl-3"
									style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}
								>
									{links.map(({ label, subLinks, path, isTitle }) => (
										<div key={uuid()} className="w-full">
											{subLinks ? (
												<>
													<h1 className="text-[#c94c67] font-bold text-left py-1 text-[20px]">
														{label}
													</h1>
													<ul className="flex flex-col">
														{subLinks.map(({ label, path }) => (
															<li key={uuid()} className="py-0">
																<a href={`${baseURL}${path}`}>
																	{label}
																</a>
															</li>
														))}
													</ul>
												</>
											) : isTitle ? (
												<a
													href={`${baseURL}${path}`}
													className="block text-left py-2 text-xl font-bold text-[#c94c67]"
												>
													{label}
												</a>
											) : (
												<a href={`${baseURL}${path}`} className="block text-left py-0">
													{label}
												</a>
											)}
										</div>
									))}
								</div>
							)}


						</>
					)}
				</ul>
			</nav>

			<div className='progress-bar' style={{ width: `${scrollWidth}%` }}>
			</div>
		</>
	);
};

export default Navbar;
